import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { statusChipStyles as sx } from './StatusChip.styles';

type Props = {
	children: ReactNode;
};

export const StatusChipTooltip = ({ children }: Props) => {
	const { t } = useTranslation();

	return (
		<Box sx={sx.info}>
			{children}
			<Tooltip
				title={t('Please allow up to 48 hours for the changes to be visible')}
				arrow
			>
				<InfoOutlineIcon sx={sx.icon} />
			</Tooltip>
		</Box>
	);
};
